import ModelTypeConstants from 'constants/ModelTypeConstants';

import {BenchlingIconName} from './BenchlingIcon';

/**
 * Enum values are expected to be valid icon names acceptable by BenchlingIcon, or otherwise you may introduce
 * a mapping in IconAliases to map to a valid icon name.
 */
export enum FolderItemIcon {
  BasicFolderItem = 'basic_folder_item',
  Sequence = 'sequence',
  Plasmid = 'plasmid',
  RNASequence = 'rna_sequence',
  OligoV2 = 'oligo-v2',
  Oligo = 'oligo',
  PrimerPair = 'primer_pair',
  Protein = 'protein',
  Entry = 'entry',
  Mixture = 'mixture',
  Molecule = 'molecule',
  Antibody = 'antibody',
  Bacteria = 'bacteria',
  CellLine = 'cell-line',
  Chromatography = 'chromatography',
  Compound = 'compound',
  Human = 'human',
  Linear = 'linear',
  Material = 'material',
  MortarPestle = 'mortar-pestle',
  Mouse = 'mouse',
  Plant = 'plant',
  Powder = 'powder',
  PowderBeaker = 'powder-beaker',
  Recipe = 'recipe',
  SampleSlide = 'sample-slide',
  SmallMolecule = 'small-molecule',
  SmallMoleculeBeaker = 'small-molecule-beaker',
  Solution = 'solution',
  Worm = 'worm',
  Worksheet = 'worksheet',
}

export const FOLDER_ITEM_ICONS: Record<string, Array<BenchlingIconName>> = {
  [ModelTypeConstants.BASIC_FOLDER_ITEM]: [
    FolderItemIcon.BasicFolderItem,
    FolderItemIcon.Sequence,
    FolderItemIcon.RNASequence,
    FolderItemIcon.OligoV2,
    FolderItemIcon.PrimerPair,
    FolderItemIcon.Protein,
    FolderItemIcon.Antibody,
    FolderItemIcon.Bacteria,
    FolderItemIcon.CellLine,
    FolderItemIcon.Chromatography,
    FolderItemIcon.Compound,
    FolderItemIcon.Human,
    FolderItemIcon.Linear,
    FolderItemIcon.Material,
    FolderItemIcon.Mouse,
    FolderItemIcon.Plant,
    FolderItemIcon.SampleSlide,
    FolderItemIcon.SmallMolecule,
    FolderItemIcon.SmallMoleculeBeaker,
    FolderItemIcon.Worm,
  ],
  [ModelTypeConstants.SEQUENCE]: [
    FolderItemIcon.Sequence,
    FolderItemIcon.Plasmid,
    FolderItemIcon.OligoV2,
    FolderItemIcon.PrimerPair,
    FolderItemIcon.Linear,
    FolderItemIcon.BasicFolderItem,
    FolderItemIcon.RNASequence,
  ],
  [ModelTypeConstants.PROTEIN]: [
    FolderItemIcon.Protein,
    FolderItemIcon.Linear,
    FolderItemIcon.BasicFolderItem,
  ],
  [ModelTypeConstants.ENTRY]: [FolderItemIcon.Entry],
  [ModelTypeConstants.DNA_OLIGO]: [FolderItemIcon.OligoV2, FolderItemIcon.Oligo, FolderItemIcon.Linear],
  [ModelTypeConstants.MIXTURE]: [
    FolderItemIcon.Mixture,
    FolderItemIcon.MortarPestle,
    FolderItemIcon.Powder,
    FolderItemIcon.PowderBeaker,
    FolderItemIcon.Recipe,
    FolderItemIcon.Solution,
  ],
  [ModelTypeConstants.MOLECULE]: [FolderItemIcon.SmallMolecule, FolderItemIcon.SmallMoleculeBeaker],
  [ModelTypeConstants.RNA_SEQUENCE]: [
    FolderItemIcon.RNASequence,
    FolderItemIcon.Sequence,
    FolderItemIcon.OligoV2,
    FolderItemIcon.PrimerPair,
    FolderItemIcon.Linear,
    FolderItemIcon.BasicFolderItem,
  ],
};
